import React from 'react'
import btech_img from '../../../assets/svg/btech_img.svg'
import mtech_img from '../../../assets/svg/mtech.svg'

import './Courses.css'

function Courses() {

    return (
        <div className='courses'>
            <div className='section__container'>
                <div className='section'>
                    <h1 className='section__header'>Programmes Offered</h1>
                    <p className='about__p'>
                        The Department offers two Undergraduate four-year programmes, which are Bachelor of Technology in Computer Science and Engineering, and Bachelor of Technology in Computer Science and Business Systems. Both these courses are affiliated to APJ Abdul Kalam Technological University (KTU).
                        <br />
                        The Department also offers a Post Graduation programme in Computer Science and Engineering with a specialization in Data Science.
                    </p>
                </div>
                <div className='courses_container'>
                    <div className='single_course'>
                        <div className='courses_img'>
                            <img src={btech_img} alt="B.Tech" />
                        </div>
                        <div className='course_name'>
                            <h1>B. Tech</h1>
                            <p>in<br /> Computer Science and Engineering</p>

                        </div>
                    </div>
                    <div className='single_course'>
                        <div className='courses_img'>
                            <img src={btech_img} alt="B.Tech" />
                        </div>
                        <div className='course_name'>
                            <h1>B. Tech</h1>
                            <p>in<br /> Computer Science and Business Systems</p>

                        </div>
                    </div>
                    <div className='single_course'>
                        <div className='courses_img'>
                            <img src={mtech_img} alt="M.Tech" />
                        </div>
                        <div className='course_name'>
                            <h1>M. Tech</h1>
                            <p>in<br /> Computer Science and Engineering
                                with Specialization <br /> in<br />
                                Data Science
                            </p>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Courses